import React from 'react';
import './NewClientPageButton.scss';

interface NewClientPageButtonProps {
  /** Full action name, e.g. 試用新版客戶頁. Shown from 600px up, and as the tooltip / screen-reader name. */
  label: string;
  /** Short form for phones, where the top bar is crowded, e.g. 新版. */
  shortLabel: string;
  onClick: () => void;
}

/**
 * The visible way into ClientV2, sitting next to the PRO badge in V1's top-nav
 * title. The PRO badge is also clickable, but nothing about a plan badge says
 * "press me for a new page" — and it is only rendered for Pro/Ultra advisers,
 * so everyone else had no way in at all. This pill is shown to every adviser
 * on /client.
 */
const NewClientPageButton = ({ label, shortLabel, onClick }: NewClientPageButtonProps) => (
  <button
    type="button"
    className="new-client-page-btn"
    data-testid="try-new-client-page"
    aria-label={label}
    title={label}
    onClick={onClick}
  >
    <span className="new-client-page-btn__short" aria-hidden="true">
      {shortLabel}
    </span>
    <span className="new-client-page-btn__full" aria-hidden="true">
      {label}
    </span>
  </button>
);

export default NewClientPageButton;
